module.exports = __webpack_public_path__ + "img/Logo-Era-Tua-Face.89be92f.svg";